/**
 * Handler event for modal
 */
import Loader from './loader';
import Elem from './elem';

class EventHandler {
    /**
     * Constructor
     * @param {string} callName
     */
    constructor({callName = ''}) {
        this.callName = callName;
    }

    /**
     * Determines which method should be called
     * @param {MouseEvent} e
     * @returns {*}
     */
    handleEvent(e) {
        let method = `on${e.type[0].toUpperCase()}${e.type.slice(1)}`;

        return this[method](e);
    }

    /**
     * Calling the form by click
     * @param {MouseEvent} e
     */
    onClick(e) {
        /** @type {HTMLButtonElement|null} */
        const target = e.target.closest(this.callName);

        if (target) {
            e.preventDefault();
            Loader.run({
                loadLink: 'index.php?route=module/simple_forms/loader',
                formData: Elem.getData(target),
            });
        }
    }
}

export default EventHandler;
